<template>
    <div class="main">
        <c-panel title="PROCESSOS DE INSCRIÇÃO" titleIcon="fas fa-clipboard-list">
            <el-row class="u-mb-15" :gutter="10">
                <el-col :xs="24" :sm="10">
                    <el-input v-model="filtro.nome" placeholder="Pesquisar processo..." @keyup.native.enter="carregar"></el-input>
                </el-col>
                <el-col :xs="24" :sm="8">
                    <el-select v-model="filtro.tipo" clearable placeholder="Tipo" style="width: 100%;" @change="carregar">
                        <el-option value="inscricao_matricula" label="Inscrição para matrícula"></el-option>
                        <el-option value="lista_espera" label="Lista de espera"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="6" class="u-text-right">
                    <router-link v-if="podeEscrever" to="/admin/processo-inscricao/cadastro" class="btn-new-register">
                        <el-button type="primary">NOVO PROCESSO</el-button>
                    </router-link>
                </el-col>
            </el-row>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Processo</th>
                            <th class="hidden-mobile">Tipo</th>
                            <th>Inscrições</th>
                            <th class="u-text-center">Canal</th>
                            <th class="u-text-center">Inscritos</th>
                            <th class="u-text-center">Situação</th>
                            <th style="width: 170px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="item in items" :key="item.id">
                            <td>{{ item.nome }}</td>
                            <td class="hidden-mobile">{{ item.tipo === 'lista_espera' ? 'Lista de espera' : 'Inscrição p/ matrícula' }}</td>
                            <td>{{ item.data_inicio | data }} a {{ item.data_fim | data }}</td>
                            <td class="u-text-center">{{ item.canal }}</td>
                            <td class="u-text-center">{{ item.inscricoes_count }}</td>
                            <td class="u-text-center">{{ item.situacao ? 'Ativo' : 'Inativo' }}</td>
                            <td class="u-text-center acao">
                                <router-link :to="'/admin/inscricao/classificacao/' + item.id" class="link-icon u-mr-10" style="color: rgba(0,0,0,.87) !important;">
                                    <el-button type="success" title="Classificação" icon="el-icon-s-data" size="mini" plain></el-button>
                                </router-link>
                                <router-link v-if="podeEscrever" :to="'/admin/processo-inscricao/edit/' + item.id" class="link-icon u-mr-10" style="color: rgba(0,0,0,.87) !important;">
                                    <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
                                </router-link>
                                <el-button v-if="podeEscrever" @click="excluir(item.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                            </td>
                        </tr>
                        <tr v-if="items.length === 0"><td colspan="7" class="u-text-center">Nenhum processo cadastrado.</td></tr>
                    </tbody>
                </table>
                <div v-if="!statusList" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>
            </div>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO D — itens 45 e 60. Interface para `api/processo-inscricao`. */
export default {
    filters: { data (v) { return v ? String(v).substring(0, 10).split('-').reverse().join('/') : '—' } },
    data: () => ({ statusList: false, filtro: { nome: '', tipo: '' }, items: [] }),
    computed: {
        podeEscrever () { return [0, 1, 3, 4, 5, 6, 7, 9, 12].includes(parseInt(this.$store.state.user.tipo)) }
    },
    mounted () { this.carregar() },
    methods: {
        carregar () {
            this.statusList = false
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/processo-inscricao/getAllPaginate?page=1`,
                this.filtro, this.$store.getters.getHeaderAuth
            ).then(r => { this.items = r.data.data || []; this.statusList = true })
             .catch(e => this.$store.commit('throwException', e))
        },
        excluir (id) {
            this.$confirm('Excluir este processo?', 'Confirmação', {
                confirmButtonText: 'Excluir', cancelButtonText: 'Cancelar', type: 'warning'
            }).then(() => {
                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/processo-inscricao/delete/${id}`,
                    this.$store.getters.getHeaderAuth
                ).then(r => {
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: 'Processo excluído.', type: 'success' })
                    this.carregar()
                }).catch(e => this.$store.commit('throwException', e))
            }).catch(() => {})
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
